import apiService from "../common/commonApi";

export const omProject = {};

omProject.list = async (param) => {    
    return apiService.Get('omproject-list', param);
}

omProject.add = async (param) => {    
    return apiService.Post('omproject-create', param);
}

omProject.delete = async (param) => {    
    return apiService.Post('omproject-delete', param);
}

omProject.update = async (param) => {    
    return apiService.Post('omproject-update', param);
}
